import { pdfCustomFieldsTranslations } from './pdf-custom-fields-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
/** Translations of the visual PDF template designer; wired up in lib/i18n/en.ts. */
export const pdfDesignerTr = {
  customFields: pdfCustomFieldsTranslations.tr,
  list: {
    title: 'PDF şablonları',
    subtitle: 'Belge düzenlerini kodlamadan tasarlayın ve bunları belge türüne göre atayın.',
    cardTitle: 'Şablonlar',
    cardDescription:
      'Bir belge türünün varsayılan şablonu yazdırma sırasında otomatik olarak uygulanır.',
    filter: 'Belge türünü filtrele',
    allTypes: 'Tüm belge türleri',
    create: 'Yeni şablon',
    created: 'Şablon oluşturuldu.',
    createTitle: 'Şablon oluştur',
    createDescription:
      'Bir belge türü ve başlangıç düzeni seçin; her ikisi de düzenlenebilir durumda kalır.',
    preset: 'Başlangıç düzeni',
    presetHint: 'Ön ayar kenar boşluklarını, yazı tiplerini, yapı taşlarını ve sütunları tanımlar.',
    active: 'Aktif',
    inactive: 'Aktif Değil',
    error: 'Şablonlar yüklenemedi.',
    emptyTitle: 'Henüz şablon yok',
    emptyHint: 'Belgelerinizin yazdırma düzenini tasarlamak için bir şablon oluşturun.',
    columns: {
      name: 'Ad',
      documentType: 'Belge türü',
      status: 'Durum',
      updatedAt: 'Son değişiklik',
    },
  },
  documentTypes: {
    QUOTE: 'Teklif',
    ORDER: 'Sipariş onayı',
    DELIVERY_NOTE: 'Teslimat notu',
    INVOICE: 'Fatura',
    PURCHASE_ORDER: 'Satınalma siparişi',
    ALL: 'Tüm belge türleri',
  },
  presets: {
    CLASSIC_DIN5008: 'Klasik DIN 5008',
    MODERN_MINIMALIST: 'Modern minimalist',
    COMPACT: 'Kompakt',
  },
  blocks: {
    RECEIVING_HOURS: deliveryPlanningTranslations.tr.receiving,
    TRANSPORT_PLAN: deliveryPlanningTranslations.tr.transport,
    LOGO: 'Şirket logosu',
    SENDER_LINE: 'Gönderen hattı',
    RECIPIENT_ADDRESS: 'Adres alanı',
    DOCUMENT_META: 'Belge veri kutusu',
    HEADER_TEXT: 'Konu satırı',
    CUSTOMER_HEADER: 'Belge başlığındaki müşteri bilgileri',
    ITEMS_TABLE: 'Satır öğesi tablosu',
    SHIPPING_SUMMARY: 'Ambalaj ve ağırlık',
    TOTALS_BLOCK: 'Toplamlar bloğu',
    GIROCODE_QR: 'GiroCode QR',
    FOOTER_TEXT: 'Ödeme koşulları',
    FOOTER_COLUMNS: 'Üç sütunlu altbilgi',
    CUSTOM_HTML_TEXT: 'Serbest metin',
  },
  columns: {
    position: 'Öğe',
    sku: 'Ürün numarası',
    name: 'Açıklama',
    description: 'Ayrıntılar',
    batchNumber: 'Toplu',
    expiryDate: 'Önceki en iyisi',
    quantity: 'Adet',
    unit: 'Birim',
    unitPrice: 'Birim fiyatı',
    discountPercent: 'İndirim',
    taxRate: 'KDV oranı',
    lineTotal: 'Toplam net',
  },
  toolbar: {
    name: 'Şablon adı',
    isDefault: 'Varsayılan',
    unsaved: 'Kaydedilmemiş değişiklikler',
    editMode: 'Düzenleme modu',
    previewMode: 'Canlı PDF önizlemesi',
    undo: 'Geri al',
    redo: 'Tekrar yap',
    resetPreset: 'Ön ayara sıfırla',
    duplicate: 'Çoğalt',
    setDefault: 'Varsayılan olarak ayarla',
    save: 'Kaydet ve etkinleştir',
  },
  library: {
    title: 'Yapı taşları',
    usedTitle: 'Kullanılan bloklar',
    add: "{{block}}'yi ekle",
  },
  canvas: {
    dragHandle: 'Bloğu taşı',
    hide: 'Bloğu gizle',
    show: 'Bloğu göster',
    remove: 'Bloğu kaldır',
    empty: 'Yapı taşlarını sol sütundan sayfaya sürükleyin.',
    resizeColumn: '{{column}} sütununun genişliğini ayarlayın',
    customerHeaderConfigured: 'Kaydedilmiş belge düzenindeki alanlar',
    customerHeaderFields: '{{count}} seçili müşteri alanı',
  },
  inspector: {
    pageTitle: 'Sayfa',
    marginsTitle: 'Sayfa kenar boşlukları (mm)',
    margin: {
      top: 'Üst',
      bottom: 'Alt',
      left: 'Sol',
      right: 'Sağ',
    },
    typographyTitle: 'Tipografi',
    fontFamily: 'Yazı tipi ailesi',
    baseFontSize: 'Temel boyut (pt)',
    lineHeight: 'Satır yüksekliği',
    colorsTitle: 'Renkler',
    primaryColor: 'Ana renk',
    secondaryColor: 'İkincil renk',
    textColor: 'Metin rengi',
    din5008Title: 'DIN 5008',
    showFoldMarks: 'Katlama işaretlerini göster',
    showPunchMark: 'Delgeç işaretini göster',
    showPageNumbers: 'Sayfa numaralarını göster',
    visible: 'Görünür',
    pageBreakBefore: 'Önceki sayfa sonu',
    content: 'Metin',
    contentHint: 'Belgede yakalanan metni kullanmak için boş bırakın.',
    positionTitle: 'Konum ve aralık',
    positionX: 'X (mm)',
    positionY: 'Y (mm)',
    positionWidth: 'Genişlik (mm)',
    positionHeight: 'Yükseklik (mm)',
    paddingTop: 'Üstteki boşluk (mm)',
    paddingBottom: 'Alttaki boşluk (mm)',
    styleTitle: 'Görünüm',
    fontSize: 'Yazı tipi boyutu (pt)',
    alignLabel: 'Hizalama',
    bold: 'Kalın',
    borderBottom: 'Alt kural',
    background: 'Arka plan rengi',
    align: {
      left: 'Sol',
      center: 'Merkez',
      right: 'Sağ',
    },
    tableDisplayTitle: 'Tablo görünümü',
    zebra: 'Zebra çizgileri',
    compact: 'Kompakt satır aralığı',
    headerBackground: 'Renk tonu üstbilgi satırı',
    headerColor: 'Başlık rengi',
    columnsTitle: 'Sütunlar',
    columnLabel: 'Etiket',
    totalsTitle: 'Toplamlar bloğu',
    showTaxBreakdown: 'KDV dökümünü göster',
    showCashDiscount: 'Nakit indirimini göster',
    girocodeTitle: 'GiroKodu',
    qrSize: 'Boyut (mm)',
    qrAlign: 'Hizalama',
    qrCaption: 'Başlığı göster',
    logoTitle: 'Logosu',
    logoHeight: 'Yükseklik (mm)',
    showCompanyAddress: 'Şirket adresini göster',
    paymentTitle: 'Bildirimler',
    showPaymentTerms: 'Ödeme koşullarını göster',
    showTaxNotice: 'Vergi bildirimini göster',
    customerHeaderTitle: 'Müşteri bilgileri',
    customerHeaderHint:
      'KDV kimlik numarası gibi seçilen herkese açık standart alanlar, belgede kayıtlı değeri gösterir. Alan eklemek bloğu etkinleştirir. Ek alanlar için PDF onayı gerekli olmaya devam eder.',
    customerHeaderSharedTypeHint:
      'Bu şablon birden çok belge türü için geçerlidir. Eksik veya onaysız alanlar güvenle atlanır.',
    customerHeaderColumns: 'Sütunlar',
    customerHeaderLabels: 'Alan etiketleri',
    customerHeaderLayoutDefault: 'Belge düzenini kullan',
    customerHeaderLabelsShow: 'Her zaman göster',
    customerHeaderLabelsHide: 'Yalnızca değerler',
    customerHeaderHideEmpty: 'Boş değerleri gizle',
    customerHeaderFields: 'Alan seçimi',
    customerHeaderUseLayout: 'Belge düzenini kullan',
    customerHeaderAllConfigured: 'Belge düzeninde PDF için onaylanan tüm alanlar gösterilir.',
    customerHeaderSelectedCount: '{{count}} alan özellikle seçildi',
    customerHeaderSelected: 'Seçili müşteri alanları',
    customerHeaderUnavailableField: 'Alan artık kullanılamıyor',
    customerHeaderMoveUp: 'Alanı yukarı taşı',
    customerHeaderMoveDown: 'Alanı aşağı taşı',
    customerHeaderRemove: 'Alanı seçimden kaldır',
    customerHeaderSearch: 'Alan veya kategori ara',
    customerHeaderSource: 'Alan türünü filtrele',
    customerHeaderCategory: 'Kategoriyi filtrele',
    customerHeaderLoadError: 'Müşteri alanları yüklenemedi.',
    customerHeaderBlocked: 'Bu alan PDF belgelerinde gösterilemez.',
    customerHeaderNoFields: 'Eşleşen, harici kullanıma onaylı alan bulunamadı.',
  },
  meta: {
    addDocument: 'Belge alanı ekle',
    add: 'Müşteri alanı ekle',
    rows: 'Belge bilgisi satırları',
    hint: 'Satırları sürükleyin veya okları kullanın. Değerler, etiketler ve PDF izinleri kayıtlı belgeden alınır. Kutu içerikle büyür; gerçek boyutunu PDF önizlemesinde kontrol edin. Diğer bloklar bağımsızdır.',
    showLabel: 'Alan etiketini göster',
    hideEmpty: 'Boş değerleri gizle',
    chooseSample: 'Kontrol için bir örnek belge seçin.',
    loadError: 'Alanlar veya belge yüklenemedi. Okuma izinlerinizi kontrol edin.',
    emptyValue: 'Boş değer',
    configureLayout: 'Müşteri başlığı PDF izinlerini yapılandır',
    configureFields: 'Özel alanları yapılandır',
    openDocument: 'Belgedeki kayıtlı alan değerlerini kontrol et',
    standard: {
      documentNumber: 'Belge numarası',
      documentDate: 'Tarih',
      customerNumber: 'Müşteri numarası',
      contactPerson: 'İlgili kişi',
      reference: 'Referans',
      serviceDate: 'Hizmet tarihi',
      deliveryDate: 'Teslimat tarihi',
      validUntil: 'Geçerlilik tarihi',
      dueDate: 'Vade tarihi',
    },
    issues: {
      documentMissingSnapshot:
        'Bu belge alanı için okunabilir bir geçmiş tanım bulunamadı. Örnek belgedeki özel alanları ve okuma yetkilerinizi kontrol edin. Güncel tanımlar geçmiş tanımların yerine kullanılmaz.',
      documentNotReleased:
        'Bu belge alanının kayıtlı tanımında veya güncel ayarlarında PDF izni yok. Özel alanlardaki “PDF’de göster” ayarını kontrol edin; şablonda seçmek izin vermez.',
      unavailable:
        'Bu alan güncel katalogda kullanılamıyor. Özel alanlarda belge türünü, alan durumunu ve okuma izinlerini kontrol edin.',
      missingSnapshot:
        'Kayıtlı değer yok. Belgedeki müşteri verilerini kontrol edin; gerekirse alanı taslakta açıkça ekleyin veya güncelleyin. Güncel ana veriler yerine kullanılmaz.',
      notConfigured:
        'Alan kayıtlı belge düzeninde yok. Belgedeki müşteri verisi seçimini kontrol edin.',
      private:
        'Dahili veya gizli alanlar PDF’de gösterilemez. Özel alan sınıflandırmasını kontrol edin; şablonda seçim izin vermez.',
      notReleased:
        'Kayıtlı belgede alan veya bölüm için PDF izni yok. Belgedeki izinleri kontrol edin; yeni belgeler için varsayılanları müşteri başlığında yapılandırın.',
      condition:
        'Kayıtlı koşul sağlanmıyor veya alan korunuyor. Belgedeki müşteri verisi yapılandırmasını kontrol edin.',
      empty: 'Kayıtlı değer boş ve gizleniyor.',
    },
  },
  preview: {
    title: 'PDF önizlemesi',
    sample: 'Örnek belge',
    refresh: 'Önizlemeyi yeniden yükle',
    updating: 'Önizleme güncelleniyor…',
    emptyTitle: 'Örnek belge mevcut değil',
    emptyHint: 'Önizlemeyi görmek için bu türde bir belge oluşturun.',
  },
  editor: {
    loadError: 'Şablon yüklenemedi.',
    copyName: '{{name}} (kopya)',
    resetTitle: 'Düzen sıfırlansın mı?',
    resetDescription:
      'Bu şablonun tüm özelleştirmelerinin yerini “{{preset}}” ön ayarı aldı. Adım geri alınabilir.',
  },
  toast: {
    saved: 'Şablon kaydedildi.',
    duplicated: 'Şablon kopyalandı.',
    defaultSet: 'Şablon artık bu belge türü için varsayılandır.',
  },
};
